import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Hero from "../components/home/Hero";
import TrustedBy from "../components/home/TrustedBy";
import DemoSection from "../components/home/DemoSection";
import Capabilities from "../components/home/Capabilities";
import ValueAddsTeaser from "../components/home/ValueAddsTeaser";
import ContactSection from "../components/home/ContactSection";
import ImpactSection from "../components/shared/ImpactSection";
import ComparisonSection from "../components/shared/ComparisonSection";

const HomePage = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth" }), 120);
    }
  }, [hash]);

  return (
    <div className="min-h-screen bg-[#04060a] text-white">
      <Navbar />
      <main>
        <Hero />
        <TrustedBy />
        <DemoSection />
        <Capabilities />
        <ValueAddsTeaser />
        <ImpactSection />
        <ComparisonSection compact />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
